import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBr from './locales/pt-BR';

i18next
  .use(initReactI18next)
  .init({
    lng: navigator.language,
    initImmediate: false,
    saveMissing: true,
    fallbackLng: 'pt-BR',
    ns: ['adm'],
    defaultNS: 'adm',
    interpolation: {
      escapeValue: false,
    },

    // debug: process.env.NODE_ENV === 'development',
    resources: {
      'pt-BR': ptBr,
    }
  });

export default i18next;
